/**
 * GapFile MDXEditor Plugin
 *
 * Renders a file attachment inline with download link.
 * Can be used within text: "See :GapFile{name="doc.pdf" rawFileName="abc123"} for details"
 *
 * MARKDOWN SYNTAX (textDirective - inline):
 * :GapFile{name="document.pdf" rawFileName="abc123"}
 */
import { DirectiveDescriptor } from "@mdxeditor/editor"
import GapFileComponent from "./GapFileComponent"

export const DIRECTIVE_NAME = 'GapFile'

export const GapFileDirectiveDescriptor: DirectiveDescriptor = {
   name: DIRECTIVE_NAME,
   type: 'textDirective',
   testNode(node) {
      return node.name === DIRECTIVE_NAME
   },
   attributes: ['name', 'rawFileName'],
   hasChildren: false,
   Editor: GapFileComponent,
}
